<template>
    <div class="p-4 flex-1 flex flex-col">
        <p class="text-[10px] font-bold uppercase tracking-[0.15em] text-primary-500 mb-3">
            Purpose
        </p>

        <div class="flex flex-wrap gap-1.5 mb-4">
            <button
                v-for="preset in presets"
                :key="preset.value"
                class="px-3 py-1.5 rounded-lg text-[11px] font-semibold transition-all duration-150"
                :class="selectedPurpose === preset.value
                    ? 'bg-primary-500 text-white shadow-sm shadow-primary-500/25'
                    : 'bg-gray-50 border border-gray-200 text-gray-600 hover:text-gray-900 hover:border-gray-300 hover:bg-gray-100'"
                @click="selectedPurpose = preset.value"
            >
                {{ preset.label }}
            </button>
        </div>

        <label class="block text-[10px] text-gray-400 mb-1.5 font-medium uppercase tracking-wider">
            Additional direction
        </label>
        <textarea
            v-model="customDirection"
            rows="3"
            placeholder="Any specific tone, details, or instructions..."
            class="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all resize-none mb-4"
        ></textarea>

        <button
            :disabled="!canGenerate"
            class="w-full py-3 rounded-lg text-sm font-bold transition-all duration-200 flex items-center justify-center gap-2"
            :class="canGenerate
                ? 'bg-primary-500 text-white shadow-lg shadow-primary-500/25 hover:bg-primary-600 hover:shadow-primary-500/35'
                : 'bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200'"
            @click="onGenerate"
        >
            <i v-if="generating" class="fa-solid fa-spinner-third fa-spin"></i>
            <i v-else class="fa-duotone fa-solid fa-wand-magic-sparkles"></i>
            <span>{{ generating ? 'Generating...' : 'Generate Email' }}</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'PurposeSelector',
    props: {
        selectedRecord: { type: Object, default: null },
        generating: { type: Boolean, default: false },
    },
    emits: ['generate'],
    data() {
        return {
            selectedPurpose: null,
            customDirection: '',
            presets: [
                { label: 'Thank You', value: 'thank-you' },
                { label: 'Follow-up', value: 'follow-up' },
                { label: 'Donation Ask', value: 'donation-ask' },
                { label: 'Event Invite', value: 'event-invite' },
                { label: 'Re-engage', value: 're-engage' },
                { label: 'Update', value: 'campaign-update' },
            ],
        }
    },
    computed: {
        canGenerate() { return !!this.selectedRecord && !!this.selectedPurpose && !this.generating },
    },
    methods: {
        onGenerate() {
            if (!this.canGenerate) return
            this.$emit('generate', { purpose: this.selectedPurpose, customDirection: this.customDirection })
        },
    },
}
</script>
